import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    orgId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.orgGroup.joinOrg, {
        orgId,
    }, options);
    if (error) return { error, status };
    return content || {};
};
